module.exports = __webpack_public_path__ + "media/components/footer/static/message-3829b5f79e76de6813f037613c7672b4.png";